import { useRequest, useView } from '@10000/react'
import { Box, Button, H3 } from '../../widgets'
import { useShell } from '../../layout'
import { assetUrl } from '../../../utilities.js'
import { SquizButton } from '../common'
import './Splash.scss'

export const Splash = ({ active }) => {
  const { questionIndex, options: { questionCount } } = useView('squiz')
  const request = useRequest('squiz')

  useShell({
    active,
    mode: 'squiz',
    step: questionIndex + 1,
    max: questionCount
  })

  const completeTeamAverage = skipConsensus => () => request('teamAverageComplete', { skipConsensus })

  return (
    <Box column fullWidth fullHeight background="var(--red)" alignItems="center" className="consensus-splash">
      <Box className="mobile-only" position="absolute" inset background={`var(--black-fade), url(${assetUrl('gifs/little-eyes-mobile.gif')}) center / cover`} />
      <Box className="desktop-only" position="absolute" inset background={`var(--black-fade), url(${assetUrl('gifs/little-eyes.gif')}) center / cover`} />

      <Box />

      <H3 align="center" mb={32} zIndex={1} lineHeight={1.2}>Start<br/>Consensus Mode</H3>

      <Box column fullWidth maxWidth={405} gap={16} zIndex={1}>
        <Button fullWidth onClick={completeTeamAverage(false)}>
          Start
        </Button>
        <SquizButton
          onClick={completeTeamAverage(true)}
          text="Skip - reveal result"
        />
      </Box>
    </Box>
  )
}